
import React,{useEffect,useState} from 'react';
import Modal from "react-bootstrap/Modal";
import { Button, ModalFooter } from 'reactstrap';
import { userUtilList } from '../../../Utils/CommonFunctions';
import PickList from '../../../Components/FormInputFields/PickList';



const CreateDomainCertificate=(props)=>{
    const [countryOptions,setCountryOptions] = useState([]);

    useEffect (()=>{
        const timer = setTimeout(() => {
            if(!countryOptions.length>0){
                updateCountryList();
            }
          }, 1000);
          return () => clearTimeout(timer);
    });

    const updateCountryList = async ()=>{
        let countryOptions = [];
        try{
              const countryList =  (await userUtilList().country_list!==undefined && await userUtilList().country_list!==null)?await userUtilList().country_list:{};
              console.log('countryList',countryList);
              Object.keys(countryList).forEach(function(key) {
                countryOptions.push({
                  value: countryList[key],
                  label: countryList[key],
                  id:key,
                })
              })
          
          }catch(e){
            console.log('e',e);
        }
        setCountryOptions(countryOptions);
      }

    const {formFieldData,isCreateNewModelOpen} =props;

  
         
    const Tittle ="Add Domain Certificate";
    const buttonlist = [
        {
            attributes:{
                "id" : "closeAddNewDomainName",
                "className" : "btn btn-border btn-default",
                "data-dismiss" : "modal"
            },
            clickHandler : props.toggleModel,
            name :'cancel'
        },{
            attributes:{
                "className" :"btn primary_bg"
            },
            clickHandler:props.saveHandler,
            name:"add"
        }
    ];

    const change=()=>{
        console.log('change input')
    }
    

    // console.log('country input options',countryOptions)
    return(
        <>
        <Modal size="xl"  buttonlist={buttonlist} show={isCreateNewModelOpen}>
            <Modal.Header>
            <h6 className="mb-0"> Add Domain Certificate  </h6>
            </Modal.Header>
            <Modal.Body>
            <div className="row" >
                    {/* <div className="col-12 col-md-4">
                        <div className={(formFieldData.unique_name.failMessage)!==''?"has-error":""}>
                            <div className="form-group">
                                <label  title="unique word for key encryption" className="w-100 text-truncate"> Unique Name </label>
                                <input  className="form-control mandatory" name='unique_name' maxLength={255} decimal={0} value={formFieldData.unique_name.value} />
                                <span className='text-danger m-1'>{formFieldData.unique_name.failMessage}</span>
                            </div>
                        </div>
                    </div> */}
                    <div className="col-12 col-md-4">
                        <div className={(formFieldData.common_name.failMessage)!==''?"has-error":""}>    
                            <div className="form-group">
                                <label  tittle = "domain name to create certificate " className="w-100 text-truncate"> Domain name </label>
                                <input onChange={props.valueChangeHandler} className="form-control mandatory" name='common_name' maxLength={255} decimal={0} value={formFieldData.common_name.value} disabled={formFieldData.common_name.disabled} />
                                <span className='text-danger m-1'>{formFieldData.common_name.failMessage}</span>  
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-4">
                        <div className={(formFieldData.email_id.failMessage)!==''?"has-error":""}>    
                            <div className="form-group">
                                <label tittle ="email address of organization or company" className="w-100 text-truncate"> Email Id </label>
                                <input onChange={props.valueChangeHandler} placeholder="" className="form-control mandatory" name='email_id' maxLength={255} decimal={0} value={formFieldData.email_id.value} disabled={formFieldData.email_id.disabled} />
                                <span className='text-danger m-1'>{formFieldData.email_id.failMessage}</span>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-4">
                        <div className={(formFieldData.company_name.failMessage)!==''?"has-error":""}>    
                            <div className="form-group">
                                <label tittle="full company name" className="w-100 text-truncate"> Company </label>
                                <input onChange={props.valueChangeHandler} placeholder="" className="form-control mandatory" name='company_name' maxLength={255} decimal={0} value={formFieldData.company_name.value} disabled={formFieldData.common_name.disabled} />
                                <span className='text-danger m-1'>{formFieldData.company_name.failMessage}</span>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-4">
                        <div className={(formFieldData.department_name.failMessage)!==''?"has-error":""}>    
                            <div className="form-group">
                                <label tittle="department working (example:- software development)" className="w-100 text-truncate"> Department </label>
                                <input onChange={props.valueChangeHandler} className="form-control mandatory" name='department_name' maxLength={255} decimal={0} value={formFieldData.department_name.value} disabled={formFieldData.department_name.disabled} />
                                <span className='text-danger m-1'>{formFieldData.department_name.failMessage}</span>
                            </div>
                        </div> 
                    </div>
                    <div className="col-12 col-md-4">
                        <div className={(formFieldData.unique_name.failMessage)!==''?"has-error":""}>
                            <div className="form-group">
                                <label  title="unique word for key encryption" className="w-100 text-truncate"> Unique Name </label>
                                <input type ="text" onChange={props.valueChangeHandler} className="form-control mandatory" name='unique_name' maxLength={255} decimal={0} value={formFieldData.unique_name.value} disabled={formFieldData.unique_name.disabled}/>
                                <span className='text-danger m-1'>{formFieldData.unique_name.failMessage}</span>
                            </div>
                        </div>
                    </div>
                    {/* <div className="col-12 col-md-4">
                        <div className={(formFieldData.state_name.failMessage)!==''?"has-error":""}>    
                            <div className="form-group">
                                <label tittle = "full state / Province name" className="w-100 text-truncate"> State / Province </label>
                                <input  className="form-control mandatory" name='state_name' maxLength={255} decimal={0} value={formFieldData.state_name.value} />
                                <span className='text-danger m-1'>{formFieldData.state_name.failMessage}</span>
                            </div>
                        </div>
                    </div> */}
                    <div className="col-12 col-md-4">
                        <div className="form-group">
                            <label  tittle = "key size for encryption" className="w-100 text-truncate"> Key Size </label>
                            <div className="selectgroup">
                                <label className="selectgroup-item mb-0">
                                    <input  type="radio"  onChange={props.valueChangeHandler} name="key_size" className="selectgroup-input" value="2048" checked={(formFieldData.key_size.value==='2048')?true:false} disabled={formFieldData.key_size.disabled}/>
                                    <span className="selectgroup-button selectgroup-button-icon">2048</span>
                                </label>
                                <label className="selectgroup-item mb-0">
                                    <input type="radio" onChange={props.valueChangeHandler} name="key_size" className="selectgroup-input" value="4096" checked={(formFieldData.key_size.value==='4096')?true:false} disabled={formFieldData.key_size.disabled} />
                                    <span className="selectgroup-button selectgroup-button-icon">4096</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-4">
                        <div className={(formFieldData.state_name.failMessage)!==''?"has-error":""}>    
                            <div className="form-group">
                                <label tittle = "full state / Province name" className="w-100 text-truncate"> State / Province </label>
                                <input onChange={props.valueChangeHandler} className="form-control mandatory" name='state_name' maxLength={255} decimal={0} value={formFieldData.state_name.value} disabled={formFieldData.state_name.disabled} />
                                <span className='text-danger m-1'>{formFieldData.state_name.failMessage}</span>
                            </div>
                        </div>
                    </div>
                    {/* <div className="col-12 col-md-4">
                        <div className={(formFieldData.email_id.failMessage)!==''?"has-error":""}>    
                            <div className="form-group">
                                <label tittle ="email address of organization or company" className="w-100 text-truncate"> Email Id </label>
                                <input  className="form-control mandatory" name='email_id' maxLength={255} decimal={0} value={formFieldData.email_id.value} />
                                <span className='text-danger m-1'>{formFieldData.email_id.failMessage}</span>
                            </div>
                        </div>
                    </div> */}
                    <div className="col-12 col-md-4">
                        <div className={(formFieldData.city_name.failMessage)!==''?"has-error":""}>    
                            <div className="form-group">
                                <label tittle ="full city name" className="w-100 text-truncate"> City </label>
                                <input onChange={props.valueChangeHandler} className="form-control mandatory" name='city_name' maxLength={255} decimal={0} value={formFieldData.city_name.value}  disabled={formFieldData.city_name.disabled}/>
                                <span className='text-danger m-1'>{formFieldData.city_name.failMessage}</span>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-4">
                        <div className={(formFieldData.country_code.failMessage)!==''?"has-error":""}>    
                            <div className="form-group">
                                <label  className="w-100 text-truncate"> Country </label>
                                {/* <input  className="form-control mandatory" name='country_code' maxLength={255} decimal={0} value={formFieldData.country_code.value} /> */}
                                
                                <PickList
                                   disabled={formFieldData.country_code.disabled}
                                   options={countryOptions}
                                   value={formFieldData.country_code.value}
                                   required={true}
                                   isDefault={false}
                                   type={"PickList"} 
                                   attributes={(formFieldData.country_code.failMessage)!==''?"has-error":""}
                                   changeHandler={props.countryChangeHandler}                               
                                />
                               
                                <span className='text-danger m-1'>{formFieldData.country_code.failMessage}</span>
                            </div>
                        </div>
                    </div>
            </div>
            </Modal.Body>
            <Modal.Footer bsPrefix='modal-footer ' >
            <button type="button" className="btn btn-cancel mr-2" onClick={props.toggleModel} data-dismiss="modal">Cancel</button>
                <button type="button" className="btn primary_bg"  onClick={props.saveHandler} disabled={false}>Add</button> 

            </Modal.Footer>
        </Modal>

        </>
        
    )
}


export default CreateDomainCertificate;